"use strict";

angular.module("customer")
.controller("SectionStocks", function(
    $rootScope, $scope, $state, $stateParams, $q, $timeout, gettextCatalog, ModalService, FlashBag, Language, common,
    UserService, StocksService, CartItemService, CartVendorService, RetailerUserInfoService,
    PromotionCatalogEntryService, PreviousStateService, StateExtensionService, IS_MOBILE
) {
    var _this = this;
    $scope.TABS = StocksService.TABS;
    $scope.updateInventoryOnReturnChoices = {
        ALWAYS: 'always',
        NEVER: 'never',
        SOMETIME: 'sometime'
    }

    Language.initializeScope($scope, "language", "locale");
    $scope.weekdays = common.getISOWeekdays($scope.locale);
    $scope.carouselService = PromotionCatalogEntryService;

    $scope.isReturn = false;
    $scope.isCustomerInventoryAvailable = false;
    $scope.isSortReady = false;

    $scope.sortFields = [];
    $scope.sortBy = {};
    $scope.ordering = {
        isFetching: false
    };
    $scope.hasBuyerSequence = {
        "value": false
    };
    $scope.shareSuggestedVendor = false;
    $scope.catalogId = $stateParams.catalog;
    $scope.isMobile = IS_MOBILE;

    function updateTab(tab) {
        $scope.activeTab = tab;
        $scope.isSales = $scope.activeTab === $scope.TABS.SALES;
        $scope.isCustomerInventoryAvailable = $scope.isSales && $scope.isOrderTemplate !== undefined && !$scope.isOrderTemplate;
        $scope.isCustomDiscount = $scope.activeTab === $scope.TABS.CUSTOM_DISCOUNTS;
        $scope.isInventoryReturn = $scope.activeTab === $scope.TABS.INVENTORY_RETURNS;
        $scope.isReturn = $scope.activeTab === $scope.TABS.RETURNS || $scope.isInventoryReturn;
        $scope.isInventoryValidationRequired = $scope.showRebate = !$scope.isReturn;

        if (!$scope.isCustomerInventoryAvailable && $stateParams.view === 'inventory') {
            $scope.currentView = 'list';
        }
    }

    this.updateView = function(tab) {
        if ($scope.activeTab === tab) {
            return
        }
        $scope.showProducts = false;
        StateExtensionService.updateUrlParams({tab: tab});
        updateTab(tab);
        resetVendorProducts();
        initVendors();
    };

    this.showTabs = function() {
        return (
            !!$scope.dedicatedVendorId
            && ($scope.allowsReturns === true || $scope.allowsCustomDiscountedPrice === true)
            && !$scope.isOrderTemplate
        );
    };

    this.isSeeAllProductAvailable = function() {
        return !$stateParams.product;
    };

    this.isBackButtonAvailable = function() {
        return $stateParams.product;
    };

    this.displaySortBy = function() {
        return $scope.sortFields.length && !$stateParams.product;
    };

    this.isCarouselAvailable = function() {
        return !$stateParams.product && $scope.isOrderTemplate !== undefined && !$scope.isOrderTemplate;
    };

    this.back = function() {
        var previousState = PreviousStateService.getPreviousState();
        $state.go(previousState.name, previousState.params);
    };

    $scope.$on("LanguageChanged", function(evt, new_locale, new_language) {
        _this.initSort();
    });

    this.onChangeSortOrder = function(sortByValue) {
        $scope.sortBy.selected = sortByValue;
        $timeout(function() {
            RetailerUserInfoService.patchCustomerUserInfo({
                customer_stock_preferred_sorting_order: $scope.sortBy.selected
            }).then(function onSuccess() {
                $scope.$broadcast("doRefreshCatalogEntries");
            });
        });
    };

    this.patchViewSelected = function(currentView) {
        $scope.currentView = currentView;
        $timeout(function() {
            RetailerUserInfoService.patchCustomerUserInfo({
                customer_catalog_view_selected: $scope.currentView
            }).then(function() {
                updateViewState();
                if ($rootScope.user && $rootScope.user.info) {
                    $rootScope.user.info.customer_catalog_view_selected = $scope.currentView;
                }
            });
        });
    };

    UserService.refreshCurrentUser().then(function(user) {
        if (user) {
            $scope.currentView = user.info && user.info.customer_catalog_view_selected;
            $scope.dedicatedVendorId = user.dedicated_vendor_id;
            $scope.allowsCustomDiscountedPrice = !!(
                user.dedicated_user_vendor
                && user.dedicated_user_vendor.allows_custom_discounted_price
            );

            var currentStateTab = $scope.TABS.SALES;
            if ($stateParams.tab) {
                currentStateTab = parseInt($stateParams.tab);
            }

            if (currentStateTab === $scope.TABS.CUSTOM_DISCOUNTS && !$scope.allowsCustomDiscountedPrice) {
                currentStateTab = $scope.TABS.SALES;
                StateExtensionService.updateUrlParams({tab: currentStateTab});
            }

            updateTab(currentStateTab);

            if ($stateParams.view && $stateParams.view !== $scope.currentView) {
                $scope.currentView = $stateParams.view;
                _this.patchViewSelected($scope.currentView);
            }
            else {
                updateViewState();
            }
        }
    }).finally(function() {
        initVendors();
    });

    function updateViewState() {
        StateExtensionService.updateUrlParams({view: $scope.currentView});
    }

    function setSearchSortOrder(value) {
        var sortBy = value;

        if (value === "buyer_catalog_sequence" && !$scope.hasBuyerSequence.value)
            sortBy = $scope.shareSuggestedVendor ? "vendor_suggested_order" : "name";

        $scope.searchSortBy = getSortOrderWithDefault(sortBy, "name");
    }

    this.initSort = function() {
        UserService.isUserFetched().then(function onSuccess() {
            var preferredSortingOrder = RetailerUserInfoService.getStockPreferredSortingOrder();
            var sortBy;

            $scope.sortFields = [{
                value: "name",
                name: gettextCatalog.getString("Name (A-Z)")
            }, {
                value: "-name",
                name: gettextCatalog.getString("Name (Z-A)")
            }, {
                value: "upc",
                name: gettextCatalog.getString("UPC (0-9)")
            }, {
                value: "-upc",
                name: gettextCatalog.getString("UPC (9-0)")
            }];

            if ($scope.catalogId && $scope.Vendors && $scope.Vendors.length === 1) {
                $scope.shareSuggestedVendor = $scope.Vendors[0].share_suggested_order;
                $scope.hasBuyerSequence.value = $scope.Vendors[0].has_buyer_sequence;

                $scope.sortFields.push({
                    value: "buyer_catalog_sequence",
                    name: gettextCatalog.getString("Custom sequence")
                });

                if ($scope.shareSuggestedVendor) {
                    $scope.sortFields.push({
                        value: "vendor_suggested_order",
                        name: gettextCatalog.getString("Vendor suggested sequence")
                    });
                }
                sortBy = "buyer_catalog_sequence";
            }
            else {
                sortBy = "name";
            }

            $scope.sortBy.selected = getSortOrderWithDefault(preferredSortingOrder || sortBy, sortBy);
        });
    };

    function getSortOrderWithDefault(value, defaultField) {
        var finalSortField = defaultField;
        var sortFields = $scope.sortFields;

        for (var i = 0, len = sortFields.length; i < len; i++) {
            var sortField = sortFields[i];
            if (sortField.value == value) {
                finalSortField = value;
                break;
            }
        }

        return finalSortField;
    }

    function initVendors() {
        StocksService.getVendors().$promise.then(function onSuccess(data) {
            $scope.Vendors = data;
            if ($scope.Vendors.length === 1) {
                $scope.allowsReturns = $scope.Vendors[0].allows_returns;
                $scope.updateInventoryOnReturn = $scope.Vendors[0].update_inventory_on_return;
                $scope.isOrderTemplate = $scope.Vendors[0].is_order_template;
            }
            else {
                $scope.isOrderTemplate = false;
            }
            _this.initSort();
            return UserService.isUserFetched().then(function onSuccess(user) {
                if (user && user.dedicated_vendor_id) {
                    CartVendorService.updateDeliveryDateList($scope.Vendors);
                }
            });
        }).finally(function() {
            updateTab($scope.activeTab);
            $scope.showProducts = true;
        });
    }

    function resetVendorProducts() {
        if (!$scope.Vendors) {
            return;
        }

        $scope.Vendors.some(function(vendor) {
            vendor.catalogEntries = [];
        });
    }

    $scope.$on("doRefreshVendor", function($event, vendor) {
        var promises = [];
        if (vendor) {
            promises.push(CartVendorService.updateCartVendor(vendor));
            // Call a blur event on the dropdown element to showing up the footer on mobile
            var selectElement = document.getElementById("select-delivery-date-" + vendor.id);
            if (selectElement) {
                selectElement.blur();
            }
        }
        $q.all(promises).then(function() {
            $scope.showProducts = false;
            resetVendorProducts();
            initVendors();
        });
    });

    $scope.$on("doUpdateSort", function($event, isSortReady, sortBySelected) {
        $scope.isSortReady = isSortReady;
        setSearchSortOrder(sortBySelected);
    });
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/stock/stock.controller.js
// module id = 921
// module chunks = 0